import "./Dashboard.scss";

import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { dashboardDisplayedEvent } from "analytics/productOfferEvents";
import { useModal } from "modules";
import { getHasMUWResult } from "store/selectors";

import { logCustomEvent } from "@braze/web-sdk";

import { ContactService } from "./ContactService/ContactService";
import HomeHeader from "./HomeHeader/HomeHeader";
import { HomeProducts } from "./HomeProducts/HomeProducts";

const Dashboard: FC = () => {
  const dispatch = useDispatch();
  const hasMUWResultNotification = useSelector(getHasMUWResult);
  const openModal = useModal();

  useEffect(() => {
    dispatch(dashboardDisplayedEvent());
    logCustomEvent("home_view");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (hasMUWResultNotification) {
      openModal("UnderwritingDecisionModal");
    }
  }, [hasMUWResultNotification, openModal]);

  return (
    <div className="dashboard-container" data-testid="dashboard__container">
      <HomeHeader />
      <HomeProducts />
      <ContactService />
    </div>
  );
};

export default Dashboard;
